// extracted by mini-css-extract-plugin
export default {"verified":"icons_verified__XX7bU"};